import { render, staticRenderFns } from "./UniversalPause.vue?vue&type=template&id=b5439cfa&"
import script from "./UniversalPause.vue?vue&type=script&lang=js&"
export * from "./UniversalPause.vue?vue&type=script&lang=js&"
import style0 from "./UniversalPause.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDataTable,VLayout})
